var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", attrs: { loading: _vm.saveLoad } },
    [
      _c("div", { staticClass: "materialFormLine" }, [_vm._v("物料信息")]),
      _c(
        "div",
        { staticClass: "budgetBox" },
        [
          _c(
            "a-form",
            {
              staticClass: "UniformCss form-container",
              attrs: {
                inline: true,
                model: _vm.material,
                "label-width": "100px",
              },
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "物料号" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.material.materialCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "materialCode", $$v)
                              },
                              expression: "material.materialCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "物料名称" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.material.materialName,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "materialName", $$v)
                              },
                              expression: "material.materialName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "物料类型" } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.material.materialType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.material, "materialType", $$v)
                                },
                                expression: "material.materialType",
                              },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "1" } }, [
                                _vm._v("销售物料"),
                              ]),
                              _c("a-select-option", { attrs: { value: "2" } }, [
                                _vm._v("礼品物料"),
                              ]),
                              _c("a-select-option", { attrs: { value: "3" } }, [
                                _vm._v("宣传物料"),
                              ]),
                              _c("a-select-option", { attrs: { value: "4" } }, [
                                _vm._v("其它"),
                              ]),
                              _c("a-select-option", { attrs: { value: "5" } }, [
                                _vm._v("产品资料"),
                              ]),
                              _c("a-select-option", { attrs: { value: "6" } }, [
                                _vm._v("手册"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "库存量" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.material.storage,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "storage", $$v)
                              },
                              expression: "material.storage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "申领单价（元）" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.material.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "price", $$v)
                              },
                              expression: "material.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "制作单价（元）" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.material.prodPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "prodPrice", $$v)
                              },
                              expression: "material.prodPrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "单位" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.material.unit,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "unit", $$v)
                              },
                              expression: "material.unit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "安全库存" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.material.storageSafetyValue,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.material,
                                  "storageSafetyValue",
                                  $$v
                                )
                              },
                              expression: "material.storageSafetyValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "备注" } },
                        [
                          _c("a-textarea", {
                            attrs: { disabled: "", rows: 1 },
                            model: {
                              value: _vm.material.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.material, "remark", $$v)
                              },
                              expression: "material.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    [
                      _c("a-form-item", { attrs: { label: "物料图片" } }, [
                        _vm.picList != null
                          ? _c(
                              "div",
                              _vm._l(_vm.picList, function (pic, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "pic-box" },
                                  [
                                    _c("el-image", {
                                      staticStyle: {
                                        width: "150px",
                                        height: "150px",
                                      },
                                      attrs: {
                                        src: pic,
                                        "preview-src-list": _vm.picList,
                                        fit: "cover",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-container" },
            [
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.returnFun()
                    },
                  },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }